import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { colorPalette, mediaQueriesBP } from "@waytek/Utilities/variables";
import { HorizontalDividerStyles, HorizontalDividerWidget } from "@waytek/Widgets/Basic/HorizontalDivider";
import * as React from "react";
import { FC } from "react";
import { css } from "styled-components";

const enum fields {
    title = "title",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
    };
}

export interface OrderDetailsTitleStyles {
    titleText: TypographyProps;
    wrapper?: InjectableCss;
}

export const titleStyles: OrderDetailsTitleStyles = {
    titleText: {
        variant: "h6",
        as: "h2",
        css: css`
            font-size: 18px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.78;
            letter-spacing: normal;
            margin-bottom: 4px;
        `,
    },

    wrapper: {
        css: css`
            margin-bottom: 20px;
        `,
    },
};

const styles = titleStyles;

const SectionTitle: FC<OwnProps> = ({ fields }) => {
    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.titleText}>{fields.title}</Typography>
            <HorizontalDividerWidget
                fields={{ color: colorPalette.common.global.industrialTaupe }}
                sizeMobile={3}
                sizeDesktop={3}
            ></HorizontalDividerWidget>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: SectionTitle,
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
        group: "Order Details",
        fieldDefinitions: [
            {
                name: fields.title,
                displayName: "Title",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "",
                isRequired: true,
            },
        ],
    },
};

export default widgetModule;
